import * as React from 'react';
import { Box, Grid, styled } from '@mui/material';
import Image from 'assets/images/LoginSignUpImage.jpg';
import theme from 'theme';

export default function SignUpLoginContainer({ children }: { children: React.ReactNode }) {
    return (
        <Container container>
            <FormColumn>{children}</FormColumn>
            <ImageGrid item sm={12} md={6} sx={{ zIndex: -1, height: '100vh' }}>
                <Box
                    component="img"
                    src={Image}
                    alt="Customer testimonial"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center center',
                    }}
                    display={{ md: 'none', lg: 'block' }}
                />
            </ImageGrid>
        </Container>
    );
}

const FormColumn = styled('div')({
    flex: 1,
    minWidth: 0,
    overflowY: 'auto',
    maxHeight: '100%',
    padding: 32,
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
        overflowY: 'visible',
        maxHeight: 'none',
        padding: 20,
    },
});

const Container = styled(Grid)({
    height: '95vh',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
        height: 'auto',
        overflow: 'visible',
    },
});

const ImageGrid = styled(Grid)({
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
});
